import React, { useState } from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import FormCreatorV2 from "../../common/FormCreatorV2";

import {
  formCreatorConvertToValues,
  useForm,
  getField,
} from "../../common/FormCreator/helpers";

import history from "../../history";
import {
  postPusterlaForms,
  submitPusterlaForms,
} from "../../redux/actions/pusterlaActions";

const PusterlaPollardsInductionQuestionnaireForm = ({
  appData,
  submitPusterlaFormsFunc,
}) => {
  const retryCounter =
    (appData &&
      appData.pusterlaOnboarding &&
      appData.pusterlaOnboarding.retryCounter) ||
    0;

  if (retryCounter >= 3) history.push("/profile/edit/pusterla-onboarding");

  const { firstName = "", lastName = "" } = appData;
  const [loading, setLoading] = useState(false);

  const initialData = {};

  const getVal = getField(initialData);

  const initialState = {
    PusterlaPollardsInductionQuestionnaire1: {
      title: "1. Who is responsible for Quality?",
      value: getVal("PusterlaPollardsInductionQuestionnaire1"),
      type: "multivalueCheckbox",
      mandatory: true,
      selectOptions: [
        { label: "a. No one", value: "a" },
        { label: "b. Only the team leader", value: "b" },
        { label: "c. Only the Quality team", value: "c" },
        { label: "d. All staff who work for Pusterla Pollards", value: "d" },
      ],
    },
    PusterlaPollardsInductionQuestionnaire2: {
      title: "2.	What should you do if you notice a hazard on site?",
      value: getVal("PusterlaPollardsInductionQuestionnaire2"),
      type: "multivalueCheckbox",
      mandatory: true,
      selectOptions: [
        { label: "a. Act and tell a team leader/manager", value: "a" },
        {
          label: "b. Ignore it as it’s someone else’s responsibility",
          value: "b",
        },
        { label: "c. Complain about it in the canteen", value: "c" },
        {
          label:
            "d. Wait until something goes wrong before saying you noticed it",
          value: "d",
        },
      ],
    },
    PusterlaPollardsInductionQuestionnaire3: {
      title:
        "3.	Which of the following are considered high risk activities at Pusterla Pollards:",
      value: getVal("PusterlaPollardsInductionQuestionnaire3"),
      type: "multivalueCheckbox",
      mandatory: true,
      selectOptions: [
        { label: "a. Manual Handling", value: "a" },
        { label: "b. Repetitive Tasks", value: "b" },
        { label: "c. Machinery", value: "c" },
        { label: "d. Vehicles", value: "d" },
        { label: "e. All of the above", value: "e" },
      ],
    },
    PusterlaPollardsInductionQuestionnaire4: {
      title: "4.	Who should we consider as a customer?",
      value: getVal("PusterlaPollardsInductionQuestionnaire4"),
      type: "multivalueCheckbox",
      mandatory: true,
      selectOptions: [
        { label: "a. Any one this isn’t me", value: "a" },
        { label: "b. I don’t really know", value: "b" },
        { label: "c. Only the person that pays the bills", value: "c" },
        { label: "d. The person that shouts the loudest", value: "d" },
      ],
    },
    PusterlaPollardsInductionQuestionnaire5: {
      title: "5.	What is considered Good Manufacturing Practice",
      value: getVal("PusterlaPollardsInductionQuestionnaire5"),
      type: "multivalueCheckbox",
      mandatory: true,
      selectOptions: [
        {
          label: "a. Locking my phone away at the start of my shift",
          value: "a",
        },
        { label: "b. Having long hair tied back", value: "b" },
        { label: "c. Wearing the PPE provided to me", value: "c" },
        { label: "d. All of the above", value: "d" },
      ],
    },
  };

  const [fields, setField] = useForm(initialState);

  const handleSubmit = async () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    const newCounter = retryCounter + 1;

    await submitPusterlaFormsFunc(
      "PusterlaPollardsInductionQuestionnaire",
      {
        answers: {
          ...fieldValuesPayload,
        },
        Signed: `${firstName} ${lastName}`,
        Name: `${firstName} ${lastName}`,
      },
      "YPUP",
      newCounter
    );

    setLoading(true);

    setTimeout(
      () =>
        history.push("/profile/edit/pusterla-onboarding/assessment/feedback"),
      6000
    );
  };

  return (
    <FormCreatorV2
      formTitle={"Pusterla Pollards Induction Questionnaire"}
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit} // handles save to JSON
      handleCancel={() => history.push("/profile/edit/pusterla-onboarding")}
      onboardingBranch={"Pusterla"}
      loading={loading}
    />
  );
};

PusterlaPollardsInductionQuestionnaireForm.propTypes = {
  appData: any,
  postPusterlaFormsFunc: func,
  submitPusterlaFormsFunc: func,
};

const mapDispatchToProps = {
  postPusterlaFormsFunc: postPusterlaForms,
  submitPusterlaFormsFunc: submitPusterlaForms,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(PusterlaPollardsInductionQuestionnaireForm);
